import api, { ApiResponse } from './api';

import { Establishment } from 'entities/Establishment';

interface GetEstablishmentListResponse {
  success: boolean;
  data: Establishment[];
}

export const getEstablishmentListService =
  (): ApiResponse<GetEstablishmentListResponse> =>
    api({
      method: 'GET',
      url: 'establishments',
      useToken: true,
    });
